import React, { useState, useEffect } from 'react';
import axios from 'axios';

const AnnunciRecenti = () => {
  const [annunci, setAnnunci] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  useEffect(() => {
    const fetchAnnunci = async () => {
      try {
        const response = await axios.get('/api/ultimi-annunci');
        setAnnunci(response.data);
        setLoading(false);
      } catch (err) {
        console.error('Errore nel recupero degli annunci:', err);
        setError('Si è verificato un errore nel caricamento degli annunci.');
        setLoading(false);
      }
    };

    fetchAnnunci();

    // Aggiorna gli annunci ogni 5 minuti (300000 millisecondi)
    const intervalId = setInterval(fetchAnnunci, 300000);

    // Pulisci l'intervallo quando il componente viene smontato
    return () => clearInterval(intervalId);
  }, []);

  if (loading) {
    return <div>Caricamento in corso...</div>;
  }

  if (error) {
    return <div className="error-message">{error}</div>;
  }
  
  const handleImageClick = (event, imageUrl) => {
    event.preventDefault(); // Previeni il comportamento di default del link
    setSelectedImage(imageUrl);
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
  };

  return (    

    <div className="container-fluid plr_30 body_white_bg pt_30">
        <div className="row mb_30 mt_30 text text-center">
            {annunci.map(annuncio => (
                <div className="col-md-4 col-sm-6 col-xs-12 mb_30 mt_30">
                    <div className="card">
                        <a 
                          href={`/necrologi/${annuncio.id_utente}/${annuncio.img}`} 
                          target="_blank" 
                          rel="noreferrer" 
                          title="Visualizza"
                          onClick={(event) => handleImageClick(event, `/necrologi/${annuncio.id_utente}/${annuncio.img}`)} // Aggiungi onClick
                        >
                          <img 
                            src={`/necrologi/${annuncio.id_utente}/${annuncio.img}`} 
                            className="card-img-top" 
                            alt={`${annuncio.nome} ${annuncio.cognome}`} 
                          />
                        </a>
                        <div className="card-body">
                            <h5 className="card-title text-center"><a href={`/necrologi/${annuncio.id_utente}/${annuncio.img}`} target="_blank" rel="noreferrer" title="Visualizza">{annuncio.nome} {annuncio.cognome}</a></h5>
                            <p className="card-text text-center" style={{marginTop: "-1vh"}}>
                              {annuncio.comune} ({annuncio.prov}) - {annuncio.regione}<br />
                              Onoranze Funebri: <b>{annuncio.ragSociale}</b>
                            </p>                            
                        </div>
                    </div>
                </div>
            ))}
        </div>
        {/* Modale */}
        {modalOpen && (
          <div className="modal">
            <div className="modal-content">
              <span className="chiudix" onClick={closeModal}>&times;</span>
              <img src={selectedImage} alt="Immagine ingrandita" />
            </div>
          </div>
        )}
    </div>
  );
};

export default AnnunciRecenti;